<template>
  <div class="index_container">
    <div v-if="cWidth > 1024">
      <!-- logo -->
      <!-- <div class="logoCon">
        <div class="w1200">
          <div class="logoCon_left">
            <img src="../assets/img/logo_mini.jpg" alt="" />
          </div>
          <div class="logoCon_right">
            <a>
              <span class="iconfont icon-weixin"></span>
              <div class="lxfs-dropdown">
                <img src="../assets/img/code.jpg" alt="" />
              </div>
            </a>
            <a>
              <span class="iconfont icon-dianhua"></span>
              <div class="lxdh-dropdown">
                <div>
                  <p>办公室：<span>23316850</span></p>
                  <p>医&nbsp;&nbsp;&nbsp;疗：<span>23126381</span></p>
                  <p>康&nbsp;&nbsp;&nbsp;复：<span>23391286</span></p>
                  <p>体&nbsp;&nbsp;&nbsp;检：<span>23128023</span></p>
                  <p>疗休养：<span>15033527324</span></p>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div> -->
      <!--轮播图-->
      <div class="swiper-container" id="home_swiper">
        <div
          class="swiper-wrapper sampleAnimation"
          v-if="imgList && imgList.length > 0"
        >
          <div
            class="swiper_meng"
            :style="{ width: 150 * imgList.length + 'vw' }"
          ></div>
          <div
            class="swiper-slide"
            v-for="item in imgList"
            :key="item.ArticleId"
          >
            <img
              v-if="item.ScrollImgList[0].ImgUrl"
              :src="item.ScrollImgList[0].ImgUrl"
            />
          </div>
        </div>
        <div v-else class="swiper-wrapper">
          <div class="swiper_meng" :style="{ width: 100 + 'vw' }"></div>
          <img
            style="margin: 0 auto; z-index: 1; width: 1000px; object-fit: cover"
            src="../assets/img/tjszgyy01.jpg"
          />
        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination"></div>
        <!-- 如果需要导航按钮 -->
        <!-- <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div> -->
      </div>
      <!-- 导航 -->
      <nav class="nomalNav">
        <div class="w1200">
          <ul>
            <li>
              <router-link :to="{ path: '/index' }">
                <a style="color: rgb(41, 177, 211) !important">首 页</a>
              </router-link>
            </li>
            <li v-for="(item, index) in navList" :key="index">
              <router-link
                :to="{
                  path: '/secondpage',
                  query: { index: index, secondindex: 0, thirdindex: '-1' },
                }"
              >
                {{ item.first }}
              </router-link>
              <!-- <a>{{ item.first }}</a> -->
              <div class="second_nav">
                <p v-for="(item2, index2) in item.second" :key="index2">
                  <router-link
                    :to="{
                      path: '/secondpage',
                      query: {
                        index: index,
                        secondindex: index2,
                        thirdindex: '-1',
                      },
                    }"
                  >
                    {{ item2.title }}
                  </router-link>
                </p>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </div>
    <div class="app_header_con" v-else>
      <!--轮播图-->
      <div class="swiper-container" id="home_swiper">
        <div class="swiper-wrapper" v-if="imgList && imgList.length > 0">
          <div
            class="swiper_meng"
            :style="{ width: 150 * imgList.length + 'vw' }"
          ></div>
          <div
            class="swiper-slide"
            v-for="item in imgList"
            :key="item.ArticleId"
          >
            <img
              v-if="item.ScrollImgList[0].ImgUrl"
              :src="item.ScrollImgList[0].ImgUrl"
            />
          </div>
        </div>
        <div v-else class="swiper-wrapper">
          <div class="swiper_meng" :style="{ width: 100 + 'vw' }"></div>
          <img
            style="margin: 0 auto; z-index: 1; width: 1000px; object-fit: cover"
            src="../assets/img/tjszgyy01.jpg"
          />
        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination"></div>
        <!-- 如果需要导航按钮 -->
        <!-- <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div> -->
      </div>
    </div>
    <!-- 医院快讯&公示公告 -->
    <div class="index_new">
      <div class="w1200">
        <div class="index_new_yykx">
          <div class="index_title" style="text-align: left">
            <h1>医院快讯</h1>
          </div>
          <el-skeleton
            class="index_new_yykx_con"
            :loading="newsLoading"
            animated
          >
            <template slot="template">
              <el-skeleton-item
                v-if="cWidth <= 1024 && cWidth > 600"
                variant="image"
                style="width: 100%; height: 35rem"
              />
              <el-skeleton-item
                v-if="cWidth <= 600"
                variant="image"
                style="width: 100%; height: 30rem"
              />
              <el-skeleton-item
                v-else
                variant="image"
                style="width: 100%; height: 29rem"
              />
            </template>
            <template>
              <Carousel
                class="index_new_yykx_con"
                :height="CarouselHeight"
                :items="items"
                :interval="interval"
              />
            </template>
          </el-skeleton>
        </div>
        <div class="index_new_gsgg">
          <div class="index_title" style="text-align: left">
            <h1>公示公告</h1>
          </div>
          <el-skeleton :loading="ggLoading" animated>
            <template slot="template">
              <div>
                <div style="width: 100%">
                  <div style="margin-top: 30px">
                    <el-skeleton-item
                      v-for="(item, index) in 8"
                      :key="index"
                      variant="text"
                      style="height: 2.2rem; margin-bottom: 1.2rem"
                    />
                  </div>
                </div>
              </div>
            </template>

            <template>
              <div class="index_news_con">
                <ul>
                  <li v-for="item in listData" :key="item.ArticleId">
                    <router-link
                      target="_blank"
                      :to="{
                        path: '/text',
                        query: {
                          articleId: item.ArticleId,
                          index: 1,
                          secondindex: 0,
                        },
                      }"
                    >
                      <div class="inner">
                        <div class="t1">
                          {{ item.Title }}
                        </div>
                        <div class="t2">{{ item.Time }}</div>
                      </div>
                    </router-link>
                  </li>
                </ul>
              </div>
              <router-link
                class="gsgg_more"
                :to="{
                  path: '/secondpage',
                  query: { index: 1, secondindex: 0 },
                }"
                >查看更多&nbsp;&nbsp;&nbsp;→</router-link
              >
            </template>
          </el-skeleton>
        </div>
      </div>
    </div>
    <!-- 业务领域 -->
    <div class="index_ksdh">
      <img src="https://www.syhos.cn/images/home/bf.jpg" alt="" />
      <div class="w1200">
        <div class="index_title">
          <h1>业务领域</h1>
        </div>
        <div class="index_ksdh_con">
          <div v-for="(item, index) in ywlyList" :key="index">
            <div class="correct">
              <div class="index_ksdh_con_icon">
                <div>
                  <span :class="item.icon"></span>
                </div>
              </div>
              <h1>{{ item.title }}</h1>
            </div>
            <div class="opposite">
              <div class="test">
                <div class="opposite-content">
                  <div class="index_ksdh_con_icon">
                    <div>
                      <span :class="item.icon"></span>
                    </div>
                  </div>
                  <p>{{ item.title }}</p>
                  <div class="opposite-content-text">
                    <p v-for="(item2, index2) in item.desc" :key="index2">
                      <router-link
                        :to="{
                          path: '/secondpage',
                          query: { index: item.id, secondindex: index2 },
                        }"
                      >
                        {{ item2.name }}
                      </router-link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div v-for="(item, index) in ywlyList" :key="index">
            <div class="index_ksdh_con_img">
              <img :src="item.imgsrc" alt="" srcset="" />
            </div>
            <div class="index_ksdh_con_title">
              <h1>{{ item.title }}</h1>
              <p>
                <span v-for="(item2, index2) in item.desc" :key="index2">{{
                  item2.name
                }}</span>
              </p>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <!-- 专家介绍 -->
    <div class="index_zjjs">
      <div class="w1200">
        <div class="index_title">
          <h1>专家介绍</h1>
        </div>
        <div class="index_zjjs_con">
          <div class="swiper-container index_zjjs_swiper" id="zjjs_swiper">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide swiper-slide-center none-effect"
                v-for="(item, index) in doctorList"
                :key="index"
              >
                <div class="index_zjjs_con_doctor">
                  <div><img :src="item.imgsrc" alt="" /></div>
                  <div>
                    <p>{{ item.name }}</p>
                    <p>{{ item.zc }}</p>
                    <p>{{ item.introduce }}</p>
                    <router-link
                      :to="{
                        path: '/text',
                        query: {
                          doctor: encodeURIComponent(JSON.stringify(item)),
                        },
                      }"
                    >
                      查看详情&nbsp;&nbsp;&nbsp;→</router-link
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-pagination"></div>
            <!-- <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- 友情链接 -->
    <div class="index_yqlj">
      <div class="w1200">
        <div class="index_title">
          <h1>友情链接</h1>
        </div>
        <div class="index_news_con">
          <div v-for="(item, index) in yqljList" :key="index">
            <div class="index_yqlj_con">
              <a :href="item.url" target="_blank">
                <img :src="item.imgsrc" alt="" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import vueSeamlessScroll from "vue-seamless-scroll";
import "swiper/swiper-bundle.css";
import { Swiper, Navigation, Pagination, Autoplay } from "swiper";
import "@/assets/js/swiper.min.js";
import "@/assets/css/swiper.min.css";
import Carousel from "../components/Carousel.vue";

export default {
  components: {
    vueSeamlessScroll,
    Carousel,
  },
  data() {
    return {
      cWidth: sessionStorage.getItem("clientWidth"),
      isAppNavShow: false,
      currentNav: -1,
      newsLoading: true,
      ggLoading: true,
      navList: [],
      currentNavIndex: 0,
      imgList: [],
      CarouselHeight: "395px",
      items: [],
      interval: 5000,
      listData: [],
      classOption: {
        step: 0.2,
      },
      slidesPerViewNumber: 4, //专家介绍一屏显示的数量
      // 专家介绍
      doctorList: [
        {
          imgsrc: require("@/assets/img/doctor/王健.jpg"),
          name: "王健",
          zc: "主任医师",
          introduce:
            "1993年毕业于河北医科大学临床医学系，2005年毕业于河北医科大学研究生学院，从事内科临床工作20余年，积累了丰富的临床经验。主持、参与完成天津市卫健委及市科委课题5项，在国家级核心期刊发表文章10余篇。擅长全科医学及老年内科疾病的治疗，对心脑血管、糖尿病以及呼吸系统疾病有着丰富的治疗经验。",
        },
        {
          imgsrc: require("@/assets/img/doctor/王富晓.jpg"),
          name: "王富晓",
          zc: "副主任医师",
          introduce:
            "1988年毕业于天津医科大学医学系，获学士学位，从事内科医疗工作20余年，积累了丰富的内科临床经验。在国家和省市级医学刊物上发表论文数篇。2003年晋升为副主任医师。擅长冠心病、高血压等内科疾病的诊疗，对于职业病尘肺、呼吸系统疾病、脑血管系统及老年病具有丰富临床经验。2003年在天津胸科医院心内科进修学习，系统学习了急危重心血管疾病的诊断、鉴别诊断及治疗。",
        },
        {
          imgsrc: require("@/assets/img/doctor/何建忠.jpg"),
          name: "何建忠",
          zc: "主任医师",
          introduce:
            "1984年毕业于天津市医学高等专科学校医疗专业，从事骨科临床工作近30年，2015年晋升为主任医师。擅长骨关节创伤的诊治。2006年开始从事肢体功能障碍康复工作，2007年在中国康复中心进修，系统学习康复专业理论及诊疗工作。曾就职于天津市河西骨科医院，现从事肢体伤残的评估及康复治疗工作。在国家和省市级医学刊物上发表论文数篇。现任天津市康复医学会颈椎病专业委员会委员、脑卒中专业委员会委员，受聘于天津医学高等专科学校康复治疗技术专业讲师。",
        },
        {
          imgsrc: require("@/assets/img/doctor/杨文生.jpg"),
          name: "杨文生",
          zc: "副主任医师",
          introduce:
            "1989年毕业于天津医科大学医学影像系，获学士学位，从事影像学工作30余年，积累了丰富的临床经验，2007年晋升为副主任医师。擅长医学影像诊断及鉴别诊断。曾在天津市第三中心医院进修，负责本院住院、门诊、劳模及社会团体查体的X光诊断工作，并为职业病尘肺鉴定工作提供可靠的影像学诊断依据。在国家和省市级医学刊物上发表论文数篇。",
        },
        {
          imgsrc: require("@/assets/img/doctor/王丽莉.jpg"),
          name: "王丽莉",
          zc: "副主任医师",
          introduce:
            "1992年毕业于天津中医学院针灸系，从事中医及康复临床工作30余年，2014年晋升为副主任医师，擅长中西结合康复治疗。现任天津市康复医学会职业康复专业委员会主任委员，中国康复医学会作业治疗专业委员会委员。",
        },
        {
          imgsrc: require("@/assets/img/doctor/张健.jpg"),
          name: "张健",
          zc: "副主任医师",
          introduce:
            "1996年毕业于天津医科大学医学系，毕业后从事骨科及康复医学专业工作近20年，2014年晋升为副主任医师。擅长各种骨科常见疾病，尤其是颈腰椎及关节疾病的诊治，在外科负责脊柱损伤，肢体伤残的诊疗康复工作，能熟练掌握肢体伤残的康复计划制定、评估及治疗。曾在天津市环湖医院、北京大学第一医院康复科培训学习。在国家和省市级医学刊物上发表论文数篇，现任天津市康复医学会理事。天津市卫健委康复医学质控中心委员。天津市医师协会康复医师分会常委。中国康复医学会居家康复专业委员会委员。天津市尘肺康复质控中心委员。",
        },
        {
          imgsrc: require("@/assets/img/doctor/于力.jpg"),
          name: "于力",
          zc: "副主任医师",
          introduce:
            "1984年毕业于天津医科大学医疗系，获学士学位，从事妇产科工作近30年，积累了丰富的临床经验，2011年晋升为副主任医师，对妇科、产科、乳腺疾病诊断、鉴别诊断及治疗积累了丰富的临床经验，尤其是乳腺癌、宫颈癌的早期诊断具有一定的临床经验，使得大多患者取得较好的预后。曾在天津市中心妇产科医院及天津市第三医院从事妇产科工作，在国家和省市级医学刊物上发表论文数篇。",
        },
        {
          imgsrc: require("@/assets/img/doctor/金玉坤.jpg"),
          name: "金玉坤",
          zc: "副主任医师",
          introduce:
            "1998年毕业于吉林医学院临床医疗系，毕业后从事临床工作近20年。2015年晋升为呼吸内科副主任医师，擅长呼吸内科系统疾病的诊断、鉴别诊断及治疗，以及冠心病、糖尿病、高血压等内科常见疾病的诊疗。2022年获得天津市卫健委全科医生培训合格证。2008年取得天津医科大学医学硕士学位。曾在天津市海河医院呼吸科及内科工作，曾参与课题《不平衡氨基酸对肝癌小鼠抑制的研究》《光动力疗法对小鼠幽门螺杆菌抑制的研究》，并获科技成果。",
        },
        {
          imgsrc: require("@/assets/img/doctor/常虹.jpg"),
          name: "常虹",
          zc: "副主任医师",
          introduce:
            "1997年毕业于天津医科大学医疗系，从事内科临床工作近20余年。2015年晋升为副主任医师，能熟练掌握内科呼吸系统、心脑血管系统疾病，特别是尘肺病的诊断、鉴别诊断和治疗。在国家和省市级医学刊物上发表论文数篇。主要从事临床内科工作。",
        },
        {
          imgsrc: require("@/assets/img/doctor/吴玉双.jpg"),
          name: "吴玉双",
          zc: "副主任医师",
          introduce:
            "1999年毕业于天津医科大学医疗系，从事内科临床工作20余年。2017晋升副主任医师。2007年取得天津医科大学硕士学位，并在北京协和医院进修ICU专业，对急危重病人的救治有了飞跃的提高。曾在天津市公安医院从事心肺疾病、内分泌及危重症的救治等内科临床工作。在核心期刊发表文章及综述4篇。研究生毕业课题《缬沙坦对人冠状动脉内皮素含量的影响》，获公安局科技成果二等奖，毕业论文《内皮素与冠心病之间的关系》，发表于《中华中西医结合杂志》，被该刊评为优秀论文。现任天津市康复医学会心血管病康复专业委员会委员。",
        },
      ],
      ywlyList: [
        {
          id: 3,
          title: "门诊介绍",
          icon: "iconfont icon-menzhenyishengzhan",
          desc: [
            { name: "门诊设置" },
            { name: "口腔门诊" },
            { name: "眼科门诊" },
            { name: "尘肺门诊" },
            { name: "康复门诊" },
            { name: "盆底肌（产后）康复门诊" },
            { name: "内科门诊" },
            { name: "工伤门诊" },
          ],
        },
        {
          id: 4,
          title: "体检服务",
          icon: "iconfont icon-icon_tijian",
          desc: [{ name: "体检中心介绍" }, { name: "体检工作动态" }],
        },
        {
          id: 5,
          title: "医疗康复",
          icon: "iconfont icon-tijian-shi",
          desc: [
            { name: "康复科介绍" },
            { name: "康复项目介绍" },
            { name: "康复医疗范围" },
            { name: "盆底肌（产后）康复门诊" },
            { name: "医疗康复动态" },
          ],
        },
        {
          id: 6,
          title: "疗休养基地",
          icon: "iconfont icon-liaoyangguanli",
          desc: [
            { name: "北戴河疗养院" },
            { name: "疗休养服务" },
            { name: "外埠合作疗养院" },
          ],
        },
      ],
      // 友情链接
      yqljList: [
        {
          imgsrc: require("../assets/img/yqlj/zgh-2.png"),
          url: "http://www.ftutj.cn/",
        },
        {
          imgsrc: require("../assets/img/yqlj/wjw.png"),
          url: "https://wsjk.tj.gov.cn/",
        },
        {
          imgsrc: require("../assets/img/yqlj/pubscholar.png"),
          url: "https://pubscholar.cn/",
        },
        {
          imgsrc: require("../assets/img/yqlj/1.1.jpg"),
          url: "https://www.oalib.com/",
        },
        {
          imgsrc: require("../assets/img/yqlj/pubmed-logo-blue.jpg"),
          url: "https://pubmed.ncbi.nlm.nih.gov/",
        },
        {
          imgsrc: require("../assets/img/yqlj/2.1.png"),
          url: "https://www.ncpssd.org/",
        },
        {
          imgsrc: require("../assets/img/yqlj/2.2-2.png"),
          url: "https://www.nstl.gov.cn/",
        },
        {
          imgsrc: require("../assets/img/yqlj/2.6.jpg"),
          url: "http://www.ucdrs.superlib.net/",
        },
        {
          imgsrc: require("../assets/img/yqlj/dxy.png"),
          url: "https://www.dxy.cn/",
        },
        {
          imgsrc: require("../assets/img/yqlj/hys.png"),
          url: "https://www.haoyisheng.com/",
        },
      ],
    };
  },
  watch: {
    imgList: {
      handler: function (newVal, oldVal) {
        this.$nextTick(() => {
          Swiper.use([Navigation, Pagination, Autoplay]);
          new Swiper("#home_swiper", {
            slidesPerView: 2, //设置slider容器能够同时显示的slides数量
            spaceBetween: 20, //slide之间的距离（单位px）
            centeredSlides: true, //设定为true时，active slide会居中，而不是默认状态下的居左。
            // observer: true, //修改swiper自己或子元素时，自动初始化swiper
            // observeParents: true, //修改swiper的父元素时，自动初始化swiper
            loop: true,
            preventInteractionOnTransition: true,
            // 如果需要前进后退按钮
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            autoplay: {
              delay: 5000, //x秒切换一次
              disableOnInteraction: false,
              waitForTransition: false,
            },
            // speed: 500,
            // speed: 1000,
            speed: 2000,
            // 如果需要分页器
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
            // swiper点击事件
            on: {
              click: (e) => {
                // console.log(e);
                // let index = e.clickedIndex;
                // let src = this.imgList[index].ScrollImgList[0].Introduction;
                // let title = this.imgList[index].ScrollImgList[0].Title;
                // const link = document.createElement("a");
                // const url = src;
                // link.href = url;
                // link.setAttribute("download", title); //window下载窗口名称自定义
                // document.body.appendChild(link);
                // link.click();
                // document.body.removeChild(link);
              },
            },
          });
        });
      },
    },
  },
  created() {
    this.navList = this.NavList;
    // 获取轮播图
    this.getList(1, 5, "f3070661-4a7c-44c7-a7c3-dff7cfa541f2", "imgList");
    // 获取公示公告
    this.getList(
      1,
      6,
      "ab34dea7-14e8-4a71-ac7c-6acf5895fd2f",
      "listData",
      "ggLoading"
    );
    // 获取医院快讯
    this.getList(
      1,
      3,
      "c0a62f93-5e28-450a-b596-52a358717db5",
      "items",
      "newsLoading"
    );
    if (this.cWidth > 1024) {
      this.slidesPerViewNumber = 4;
    } else {
      if (this.cWidth <= 800) {
        this.slidesPerViewNumber = 1;
      } else {
        this.slidesPerViewNumber = 2;
      }
    }
  },
  mounted() {
    $(window).scrollTop(0);
    $(".nomalNav li").mouseover(function () {
      $(this)
        .children("")
        .next(".second_nav")
        .stop(true, true)
        .delay(200)
        .slideDown(200);
    });
    $(".nomalNav li").mouseleave(function () {
      $(this)
        .children("")
        .next(".second_nav")
        .stop(true, true)
        .delay(200)
        .slideUp(100);
    });

    setTimeout(() => {
      new Swiper("#zjjs_swiper", {
        slidesPerView: this.slidesPerViewNumber,
        spaceBetween: 10,
        loop: true,
        speed: 1000,
        // autoplay: true,
        autoplayDisableOnInteraction: false,
        disableOnInteraction: true,
        observer: true,
        observeParents: true,
        pagination: ".swiper-pagination",
        paginationClickable: true,
        mousewheelControl: true,
        debugger: true,
        // 如果需要分页器
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    }, 100);
  },
  methods: {
    //获取数据
    getList(pageIndex, pageSize, articlesTypeId, list, loading) {
      this[loading] = true;
      let url = this.Api + "/webapi/Article/GetArticleListByType";
      let item = {
        PageIndex: pageIndex,
        PageSize: pageSize,
        ArticlesTypeId: articlesTypeId,
      };
      let that = this;
      $.ajax({
        url: url,
        type: "POST",
        data: item,
        dataType: "json",
        success: function (res) {
          if (res.status === 1) {
            that[list] = res.messageJson;
            that[loading] = false;
          }
        },
        error: function (error) {
          console.log(error);
        },
      });
    },
  },
};
</script>

<style>
.index_container {
  overflow: hidden;
  background: #fff;
}
/*轮播图*/
#home_swiper {
  width: 100%;
  /* height: 420px; */
  height: 31rem;
  position: relative;
}
#home_swiper .swiper_meng {
  /* width: 400vw; */
  height: 100%;
  background: rgba(37, 37, 37, 0.75);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}
#home_swiper .swiper-wrapper {
  -webkit-transition-timing-function: linear;
  -moz-transition-timing-function: linear;
  -ms-transition-timing-function: linear;
  -o-transition-timing-function: linear;
  transition-timing-function: linear;
}
#home_swiper .swiper-slide {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.5s;
}
#home_swiper .swiper-slide > img {
  /* width: 1000px; */
  width: 110%;
  min-height: 100%;
}
#home_swiper .swiper-slide-active,
#home_swiper .swiper-slide-duplicate-active {
  transform: scale(1);
  transition: 0.5s;
  z-index: 2001;
}
#home_swiper .swiper-pagination-bullet {
  transform: scale(0.574);
  width: 1.1rem;
  height: 1.1rem;
  background: rgba(255, 255, 255, 0.4);
  transition: all 0.2s cubic-bezier(0.55, 0.06, 0.68, 0.19) 0s;
  opacity: 1;
  border-radius: 100%;
  margin: 0 0.9rem;
  /* transition: 0.5s; */
}
#home_swiper .swiper-pagination-bullet-active,
#home_swiper .swiper-pagination-bullet:hover {
  transform: scale(1);
  background: white;
}
#home_swiper .swiper-button-prev,
#home_swiper .swiper-button-next {
  color: #fff;
  background: transparent;
}
#home_swiper .swiper-button-prev {
  left: 3%;
}
#home_swiper .swiper-button-next {
  right: 3%;
}
#home_swiper .swiper-button-prev:after,
#home_swiper .swiper-button-next:after {
  font-size: 45px;
}

/* 顶部结束 */
/* 标题 */
.index_title {
  width: 100%;
  text-align: center;
}

.index_new_gsgg .gsgg_more,
.index_zjjs_con_doctor > div:nth-child(2) > a {
  display: block;
  text-align: center;
  text-decoration: none;
  width: 10.7rem;
  height: 3.6rem;
  line-height: 3.6rem;
  font-size: 1.2rem;
  margin-top: 2.5rem;
  color: #fff;
  background: #097da4;
  font-weight: 400;
}
.index_zjjs_con_doctor > div:nth-child(2) > a {
  position: absolute;
  width: 7rem;
  height: 2.1rem;
  line-height: 2.1rem;
  font-size: 0.95rem;
  bottom: 0;
  right: 0;
  background: #dcdcdc;
  color: #333;
}

/* 医院快讯&公示公告 */
.index_new {
  width: 100%;
  padding: 5.7rem 0;
  background: #f5f5f5;
}
.index_new > div {
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
}
.index_new_yykx {
  width: 49%;
}
.index_new_gsgg {
  width: 54%;
}
.index_new_yykx_con {
  width: 92%;
  margin-top: 2.5rem;
  /* height: 400px; */
}
.index_new_yykx_con .el-carousel__container {
  height: 29rem !important;
}
/* 新闻内容 */
.index_news_con {
  width: 100%;
  /* height: calc(100% - 44px); */
  /* padding-top: 10px; */
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  margin-top: 0.7rem;
}
.index_news_con > ul {
  width: 100%;
  height: 100%;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: space-around;
}
.index_news_con > ul > li {
  width: 100%;
  font-size: 1.1rem;
  box-sizing: border-box;
  position: relative;
  cursor: pointer;
}
.index_news_con > ul > li > div {
  width: 100%;
  height: 33rem;
}
.index_news_con > ul > li > a {
  display: block;
  width: 100%;
  height: 2.9rem;
  color: #333;
  border-bottom: 1px solid #dddddd;
}
.index_news_con > ul > li > a:hover {
  color: #0182ac;
  border-bottom: 1px solid #0182ac;
}
.index_news_con > ul > li > a .inner {
  width: 100%;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: reverse;
  flex-direction: column-reverse;
  /* padding: 25px 0 0; */
  /* height: 106px; */
  margin-top: 1.1rem;
  -webkit-box-pack: end;
  justify-content: flex-end;
  flex-wrap: nowrap;
  position: relative;
}
.index_news_con > ul > li > a .inner .t1 {
  width: calc(100% - 9rem);
  /* height: 1.5rem; */
  font-size: 1.15rem;
  /* margin-top: 5px; */
  transition: all 0.3s ease-in-out;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  display: -webkit-box;
  /* 弹性盒子元素垂直排列 */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.index_news_con > ul > li > a .inner .t2 {
  font-size: 1.15rem;
  font-family: "avian";
  color: #909090;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}
.index_news_con > ul > li:hover {
  color: #0182ac;
}
/* 专家介绍 */
.index_zjjs {
  width: 100%;
  background: #f5f5f5;
  padding: 5.7rem 0;
}
.index_zjjs_con {
  width: 100%;
  height: 43rem;
  margin-top: 1.8rem;
  position: relative;
}
.index_zjjs_swiper {
  /* width: 90%; */
  height: 100%;
  /* margin: 0 5%; */
  width: 100%;
  overflow: hidden;
}
.index_zjjs_swiper .swiper-slide {
  display: flex;
  justify-content: center;
  margin-top: 0.7rem;
}
.index_zjjs_swiper .swiper-slide > a {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
}
.index_zjjs_con_doctor {
  /* width: 92%; */
  /* width: 98%; */
  width: 98%;
  margin: 0 1%;
  height: 88%;
  /* height: 35rem; */
  background: #fff;
  /* box-shadow: 0 0 20px rgba(0, 0, 0, 0.09); */
  position: relative;
}
.index_zjjs_con_doctor:hover {
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  transition: 0.5s;
}

.index_zjjs_con_doctor:hover > div:nth-child(2) > a {
  background: #087da3;
  color: #fff;
  transition: 0.5s;
}
.index_zjjs_swiper .swiper-pagination-bullet {
  width: 0.9rem;
  height: 0.9rem;
  background: #c4c4c4;
  transition: all 0.2s cubic-bezier(0.55, 0.06, 0.68, 0.19) 0s;
  opacity: 1;
  border-radius: 100%;
  margin: 0 0.9rem;
  transition: 0.5s;
}
.index_zjjs_swiper .swiper-pagination-bullet-active,
.index_zjjs_swiper .swiper-pagination-bullet:hover {
  width: 1.8rem;
  height: 0.9rem;
  border-radius: 0.4rem;
  opacity: 1;
  background-color: #0182ac;
  transition: 0.5s;
}
.index_zjjs_con .swiper-button-prev,
.index_zjjs_con .swiper-button-next {
  width: 4.2rem;
  /* height: 71px; */
  color: #d0d0d0;
  background: transparent;
}
.index_zjjs_con .swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 0rem;
}
.index_zjjs_con_doctor > div:nth-child(1) {
  width: 100%;
  height: 60%;
  overflow: hidden;
  position: relative;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
}
.index_zjjs_con_doctor > div:nth-child(1) > img {
  width: 90%;
  height: 130%;
  object-fit: cover;
  margin: 5%;
}
.index_zjjs_con_doctor > div:nth-child(2) {
  width: 100%;
  height: 40%;
  padding: 5%;
  box-sizing: border-box;
  position: relative;
}
.index_zjjs_con_doctor > div:nth-child(2) > p {
  margin-bottom: 0.6rem;
}
.index_zjjs_con_doctor > div:nth-child(2) > p:nth-child(1) {
  color: #0182ac;
  font-weight: 500;
  font-size: 1.3rem;
}
.index_zjjs_con_doctor > div:nth-child(2) > p:nth-child(2) {
  font-size: 1.1rem;
  font-weight: 400;
  color: #606060;
}
.index_zjjs_con_doctor > div:nth-child(2) > p:nth-child(3) {
  font-size: 1.05rem;
  font-weight: 400;
  width: 100%;
  /* height: 6.4rem; */
  overflow: hidden;
  color: #6b6b6b;
  display: -webkit-box;
  /* 弹性盒子元素垂直排列 */
  -webkit-box-orient: vertical;
  /* 控制要显示的行数 */
  -webkit-line-clamp: 4;
  line-height: 160%;
  text-align: justify;
}
/* 科室导航变为业务领域 */
.index_ksdh {
  width: 100%;
  background: #fff;
  padding: 5.7rem 0;
  /* margin: 40px 0; */
  position: relative;
}
.index_ksdh > img {
  width: 100%;
  height: 43rem;
  opacity: 0.4;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.index_ksdh_con {
  margin-top: 1.8rem;
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
}
.index_ksdh_con > div {
  width: 23%;
  height: 30rem;
  margin: 1% 0;
  /* box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
  background: #0181ac0f; */
  cursor: pointer;
  position: relative;
  -webkit-perspective: 57rem;
  -moz-perspective: 57rem;
}
.index_ksdh_con > div > div {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  /*动画元素transform-style*/
  -webkit-transform-style: preserve-3d;
  -moz-transform-style: preserve-3d;
  -webkit-transition: 0.8s ease-in-out;
  -moz-transition: 0.8s ease-in-out;
  /*动画元素背后设置为hidden*/
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
}
.index_ksdh_con > div h1 {
  text-align: center;
  font-size: 1.6rem;
  color: #0182ac;
}
.index_ksdh_con > div:nth-child(2),
.index_ksdh_con > div:nth-child(4) {
  margin-top: 4.3rem;
}

.index_ksdh_con_icon {
  width: 100%;
  height: 65%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.index_ksdh_con_icon > div {
  border-radius: 50%;
  width: 8.6rem;
  height: 8.6rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #0182ac;
  position: relative;
}
.index_ksdh_con_icon > div::after {
  content: "";
  position: absolute;
  border-radius: 50%;
  width: 9.6rem;
  height: 9.6rem;
  border: 1px solid #0182ac;
}
.index_ksdh_con_icon > div > span {
  color: #fff;
  font-size: 4.3rem;
}
.index_ksdh_con > div:hover .correct {
  -webkit-transform: rotateY(-180deg);
  -moz-transform: rotateY(-180deg);
}

.index_ksdh_con > div:hover .opposite {
  -webkit-transform: rotateY(0);
  -moz-transform: rotateY(0);
}

.correct {
  position: absolute;
  width: 100%;
  height: 100%;
  background: #0181ac0f;
  /*
	            绕y轴旋转
	            */
  -webkit-transform: rotateY(0);
  -moz-transform: rotateY(0);
  /* z-index: 2; */
}

.opposite {
  width: 100%;
  height: 100%;
  background: rgba(250, 249, 250, 100);
  /* background: #fff; */
  -webkit-transform: rotateY(180deg);
  -moz-transform: rotateY(180deg);
  /* z-index: 1; */
}

.opposite > div {
  width: 100%;
  overflow: hidden;
}

.opposite-content {
  display: table;
  width: 100%;
  height: 100%;
  padding-top: 1.5rem;
  box-sizing: border-box;
  font-size: 1.3rem;
  color: #0179a1;
  text-align: center;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
.opposite-content > .index_ksdh_con_icon > div {
  width: 4rem;
  height: 4rem;
}
.opposite-content > .index_ksdh_con_icon > div > span {
  font-size: 2.5rem;
}
.opposite-content > .index_ksdh_con_icon > div::after {
  width: 5rem;
  height: 5rem;
}
.opposite-content > p {
  width: 80%;
  margin: 0 10%;
  text-align: center;
  /* margin-top: 20px; */
  padding: 0.8rem 0;
  border-bottom: #eeeeee 2px solid;
}
.opposite-content-text {
  width: 80%;
  /* display: table-cell;
  vertical-align: middle;
  text-align: left;
  text-align: justify; */
  /* color: white; */
  color: #74757f;
  font-size: 1.1rem;
  padding: 0.7rem 1.4rem 1.4rem 1.4rem;
  box-sizing: border-box;
}
.opposite-content-text > p {
  height: 1.85rem;
  line-height: 1.85rem;
  text-align: center;
  /* padding: 0 10px; */
  color: #fff;
  background: #0181ac1b;
  margin: 0.4rem 0;
  font-size: 1.1rem;
  cursor: pointer;
  font-weight: 400;
}
.opposite-content-text > p > a {
  width: 100%;
  display: block;
  height: 100%;
  color: #0182ac;
}
.opposite-content-text > p:hover {
  background: #0182ac;
}
.opposite-content-text > p:hover a {
  color: #fff;
}
/* 友情链接 */
.index_yqlj {
  width: 100%;
  /* height: 25rem; */
  padding: 5.7rem 0;
  /* background: #f5f5f5; */
}
.index_yqlj > div {
  height: 100%;
}
.index_yqlj .index_news_con {
  width: 100%;
  /* height: 100%; */
  /* height: calc(100% - 5.9rem - 1.5rem); */
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  flex-wrap: wrap;
  margin-top: 2.8rem;
  padding: 1rem 0;
  box-sizing: border-box;
}
.index_yqlj .index_news_con > div {
  /* width: 100%;
  height: 100%; */
  width: 18.8%;
  margin: 0.5% 0.6%;
  height: 6.4rem;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  transition: all 1s ease 0s;
  box-shadow: 0 0 0.8rem rgba(0, 0, 0, 0.09);
  border-radius: 0.3rem;
}

.index_yqlj_con {
  width: 100%;
  height: 100%;
}
.index_yqlj_con > a {
  display: block;
  width: 100%;
  height: 100%;
  position: relative;
  background: #ffffff;
  /* margin: 1.5rem 3rem; */
  /* padding: 5px 10px; */
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
}
.index_yqlj_con > a > img {
  width: 90%;
  height: auto;
  /* width: 200px; */
  max-height: 80%;
  /* object-fit: cover; */
}
.index_yqlj .index_news_con > div:hover {
  -webkit-box-shadow: 0px 0px 0.5rem 0.5rem rgba(0, 0, 0, 0.08);
  box-shadow: 0px 0px 0.5rem 0.5rem rgba(0, 0, 0, 0.08);
}
</style>